module.exports = __webpack_public_path__ + "static/103_home-0a17c6ff884431b5c4014f4fe65d87a9.png";